export default __webpack_public_path__ + "adf7dcd7e52111238f5ba784ff86a3e2.svg";